import { ActionReducerMap } from '@ngrx/store';

import { artistsReducer, ArtistsState } from './artists.reducer';
import { favouritesReducer, FavouritesState } from './favourites.reducer';
import { primaryInterestReducer, PrimaryInterestState } from './primary-interests.reducer';

export interface PreferencesState {
  artists: ArtistsState;
  favourites: FavouritesState;
  primaryInterests: PrimaryInterestState;
}

export const preferencesReducers: ActionReducerMap<PreferencesState> = {
  favourites: favouritesReducer,
  artists: artistsReducer,
  primaryInterests: primaryInterestReducer,
};
